import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Parametro } from 'src/app/models/Parametro';
import { ModalNotificacionComponent } from '../../Denunciante/ModalNotificacion/modal-notificacion.component';
import { NavModalComponent } from '../../General/nav-modal/nav-modal.component';

@Component({
  selector: 'app-modal-instrucciones-mp',
  templateUrl: './modal-instrucciones-mp.component.html',
  styleUrls: ['./modal-instrucciones-mp.component.css']
})
export class ModalInstruccionesMpComponent implements OnInit {

  @ViewChild(NavModalComponent) navModalC: NavModalComponent;

  constructor(@Inject(MAT_DIALOG_DATA) public data: Parametro,
              public dialogRef: MatDialogRef<ModalNotificacionComponent>, ) { }

  ngOnInit() {

    this.navModalC.setDatosNavModal2('MEDIDAS DE PROTECCIÓN Y BENEFICIOS');

  }

  _cancelar() {

    this.dialogRef.close();

  }

}
